import _ from 'lodash'
import config from '../config'
//import FetchSerieses from './actions/getSerieses'
const axios = require('axios')

// const Serieses = require('./actions/getSerieses')
// import Serieses from './actions/getSerieses'
const FetchSerieses = require('./actions/getSerieses').default
//console.log('FetchSerieses :', FetchSerieses)
const { getSeriesesJsonList } = require('../series-data/get-serieses')

const _mapping = [
  { 'name': 'serieses', 'block_id': '' },
  { 'name': 'top-menu-index', 'block_id': '1000000002000003', 'board_id': 'B20200609000001' }
]

const getDataFromiPost = (block_id, board_id) => {
  return new Promise((resolve, reject) => {
    try {
      let url = `${config["iPostJsonApi"]}/${block_id}/${board_id}`
      axios.get(url)
        .then(res => resolve(res['data']))
    }
    catch (ex) {
      reject(ex)
    }
  })
}


export const actions = {
  apiGetBuildings({ commit }, success, error) {

  },

  getSerieses({ commit, state, getters }, next) {
    commit('UpdateSeriesesFilesLoading', true)

    return new Promise(resolve => {
      //FetchSerieses.getSerieses(state.seriesesFiles)

      getSeriesesJsonList()
        .then(function (jsonList) {
          commit('UpdateSeriesesFiles', jsonList)

          FetchSerieses.getSerieses(jsonList, state)
            .then(_serieses => {
              console.log('>>> [action.js] #id ',
                FetchSerieses.id,
                'getSerieses',
                '#44 serieses',
                'getters.Serieses',
                getters.Serieses,
                'state.seriesesInState',
                state.seriesesInState,
                '_serieses',
                _serieses)

              //state.seriesesInState = _serieses

              console.log('>>> [action.js]',
                'FetchSerieses.getData()',
                FetchSerieses.getData(jsonList, state))

              commit('UpdateSerieses', FetchSerieses.getData(jsonList, state))

              state.serisesInState = _serieses

              console.log('>>> [action.js]',
                'getSerieses',
                '#4 serieses',
                'getters.Serieses',
                getters.Serieses,
                'state.seriesesInState',
                state.seriesesInState)

              commit('UpdateSeriesesFilesLoading', false)

              if (next) {
                setTimeout(function () { next(FetchSerieses.getData(jsonList, state)); })
              }

              resolve(FetchSerieses.getData(jsonList, state))
            })
        })
    })
  },

  updateCourseInState({ commit, state }, course) {
    state.currentCourse = course

    // commit SET_CURRENT_COURSE in mutation
    commit('SetCurrentCourse', course)

    return state.currentCourse
  },

  getTopMenuForIndex: async ({ commit, state }, item_name) => {
    let index = _.findIndex(_mapping, { 'name': item_name })

    if (index == -1) return ''

    var item = _mapping[index]
    let result = await getDataFromiPost(item['block_id'], item['board_id'])

    // console.log('actions.js', 'getTopMenuForIndex', 'result : ', result)
    result = result['iBoard']['ContentC']

    return result
  }
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js